<template lang="pug">
  div
    .filter(@click="open")
      .filter__label {{ name }}:
      .filter__value {{ text }}
    MobileModal(
      ref="modal"
      :name="name"
      :hideFooter="!changed"
      @cancel="cancel"
      @apply="apply"
    )
      slot(name="filter")
</template>

<script>
import MobileModal from '@/components/MobileModal'
import { isEqual } from 'lodash'

export default {
  name: 'MobileFilter',
  props: {
    name: String,
    text: String,
    initialValue: String
  },
  components: {
    MobileModal
  },
  computed: {
    changed () {
      return !isEqual(this.initialValue, this.$attrs.value)
    }
  },
  methods: {
    open () {
      this.$refs.modal.open()
    },
    cancel () {
      this.$emit('input', this.initialValue)
    },
    apply () {
      this.$emit('change', this.$attrs.value)
    }
  }
}
</script>
